import { useId, useState } from 'react';
import { Button, Field } from '@beyond-js/ui/react';
import { usePresence } from '@accounts/session';

/**
 * A new password, with the one policy's rules shown and checked as the person types (ACC-02, ACC-09):
 * the length here, and whether it is common or leaked when it is sent, which only the service can say.
 * Shown or hidden by a named toggle; the value is never kept anywhere but this field. `required` makes its form
 * wait quietly while it is empty (D183, `Form`); a password shorter than the rule is the screen's to say.
 */
export function NewPassword({ label, value, onChange, error, min = 10, required = false }: { label: string; value: string; onChange: (value: string) => void; error?: string; min?: number; required?: boolean }) {
	const { text } = usePresence();
	const [shown, setShown] = useState(false);
	const rules = useId();
	const long = [...value].length >= min;
	return (
		<div className="flex flex-col gap-2">
			<Field label={label} error={error} hint={text('password.rule.length', { min })}>
				<input type={shown ? 'text' : 'password'} autoComplete="new-password" required={required} value={value} onChange={event => onChange(event.target.value)} />
			</Field>
			<div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2">
				<ul id={rules} aria-hidden="true" className="flex flex-col gap-0.5 text-small text-ink-muted">
					<li data-met={long ? 'yes' : 'no'}>
						<span aria-hidden="true">{long ? '✓' : '·'}</span> {text('password.rule.length', { min })}
					</li>
					<li>
						<span aria-hidden="true">·</span> {text('password.rule.common')}
					</li>
				</ul>
				<Button type="button" variant="quiet" small onClick={() => setShown(!shown)} aria-pressed={shown}>
					{text(shown ? 'password.hide' : 'password.show')}
				</Button>
			</div>
		</div>
	);
}
